import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { Advertiser, UserProfile } from '@/api-interfaces';
import { getUserProfile } from '../../dataProvider/dataProvider';

export const useAdvertiserData = () => {
  const {
    data: userProfile,
    isLoading,
    error,
  } = useQuery<UserProfile>({
    queryKey: ['user-profile'],
    queryFn: () =>
      getUserProfile().then(profile => profile || { message: 'no-profile' }),
    // The global QueryClient default is `gcTime: 0`, which discards this
    // query the instant its observers drop to zero. Because AdvertiserLayout
    // remounts on navigation (it sits inside the keyed page-transition) and
    // gates the whole page behind `isLoading`, that GC caused the dashboard
    // to mount → unmount (refetch loading) → remount — a visible 1-frame
    // flash. The profile is session-stable, so cache it: never goes stale,
    // survives remounts, so `isLoading` stays false after the first load.
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const advertisers = useMemo<Advertiser[]>(() => {
    return userProfile?.advertisers || [];
  }, [userProfile?.advertisers]);

  return { advertisers, isLoading, error };
};
